import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import 'autotrack';
import './api/firebaseClient';
import App from './App';
import router from './router';
import store from './store/store';

require('./sass/bundles/main.scss');

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://7287703952304574a232da7cd3f86acf@sentry.io/1473389',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

const vuetifyOptions = {
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#2C955C',
        secondary: '#F7F7F7',
        dark: '#545460'
      }
    }
  }
};
Vue.use(Vuetify);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js